import { render, staticRenderFns } from "./elDragSelect.vue?vue&type=template&id=2444afbc&scoped=true&"
import script from "./elDragSelect.vue?vue&type=script&lang=js&"
export * from "./elDragSelect.vue?vue&type=script&lang=js&"
import style0 from "./elDragSelect.vue?vue&type=style&index=0&id=2444afbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444afbc",
  null
  
)

export default component.exports